import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  UserCredential,
  User
} from "firebase/auth";

class AuthService {
  
  restoreAuth(): Promise<User|null> 
  {
    const auth = getAuth();
    return new Promise(rs => {
      const unsubscribe = onAuthStateChanged(auth, (user: User|null) => {
        rs(user); unsubscribe();
      })
    })
  }
  
  signIn(email: string, password: string): Promise<User|null>
  {
    return new Promise(resolve => {
      const auth = getAuth()
      return setPersistence(auth, browserLocalPersistence).then(() => {
        signInWithEmailAndPassword(getAuth(), email, password).then((data: UserCredential) => {
          resolve(data.user)
        }).catch(err => {
          console.error(err)
          resolve(null)
        });
      }).catch(err => {
        console.error(err)
        resolve(null)
      })
    })
  }

  async signOut() 
  {
    return signOut(getAuth())
      .then((resp) => resp)
      .catch((err) => console.log(err));
  }
}
export const authService = new AuthService();
